import { render, staticRenderFns } from "./cardMgt.vue?vue&type=template&id=ae42c4c2&scoped=true&"
import script from "./cardMgt.vue?vue&type=script&lang=js&"
export * from "./cardMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae42c4c2",
  null
  
)

export default component.exports